// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3bgLx","header":"style_header__2a5ej","paragraph":"style_paragraph__iyzFq","btnWrapper":"style_btnWrapper__3L_p_","textWrapper":"style_textWrapper__2oXIO"};